module.exports = __webpack_public_path__ + "static/sponsorship_img-06-a@2x-296fe3f7f7ade0bf4456bc12037e7d3e.jpg";